window.addEventListener('load', () => {

    function isAnyDetailsOpen(menu) {
        return Array.from(
            menu.querySelectorAll('header-menu details')
        ).some(details => details.hasAttribute('open'));
    }

    function setupDetailsObserver(menu, activeItem) {
        const detailsList = menu.querySelectorAll('header-menu details');

        detailsList.forEach(details => {
            const observer = new MutationObserver(() => {
                if (!isAnyDetailsOpen(menu)) {
                    activeItem.style.textDecoration = 'underline';
                }
            });

            observer.observe(details, {
                attributes: true,
                attributeFilter: ['open'],
            });
        });
    }

    document.addEventListener("click", function (event) {
        document.querySelectorAll("details.mega-menu[open]").forEach((menu) => {
            if (!menu.contains(event.target)) {
                menu.removeAttribute("open");
            }
        });
    });
    document.querySelectorAll('a.header__menu-item').forEach(item => {
        item.addEventListener('mouseenter', () => {
            document.querySelectorAll('details.mega-menu[open]').forEach(menu => {
                menu.removeAttribute('open');
            });
        });
    });

    document.querySelectorAll('header').forEach(menu => {
        const activeItem = menu.querySelector('span.header__active-menu-item');
        const links = menu.querySelectorAll('.header__menu-item.list-menu__item');

        if (!activeItem) return;

        setupDetailsObserver(menu, activeItem);

        links.forEach(link => {
            link.addEventListener('mouseover', (event) => {
                if (event.target !== activeItem) {
                    activeItem.style.textDecoration = 'none';
                }
            });

            link.addEventListener('mouseout', (event) => {
                if (event.target !== activeItem && !isAnyDetailsOpen(menu)) {
                    activeItem.style.textDecoration = 'underline';
                }
            });
        });
    });
});
